import React, { } from 'react';
import moment from 'moment';
import { IntlProvider } from 'react-intl';
import { ConfigProvider } from '@lockerpm/design';
import { connect } from 'react-redux';
import vi_VN from '@lockerpm/design/es/locale/vi_VN';
import en_US from '@lockerpm/design/es/locale/en_US';
import locale from '../locale/index';

import '../config/global'
import 'moment/locale/vi';

const Locales = (props) => {
  const localeIntl = {
    locale: props.locale,
    messages: props.locale === 'en' ? locale.en : locale.vi,
  };
  moment.locale(props.locale);
  return (
    <IntlProvider {...localeIntl}>
      <ConfigProvider
        locale={props.locale === 'en' ? en_US : vi_VN}
      >
        {props.children}
      </ConfigProvider>
    </IntlProvider>
  );
};

export default connect(
  (state) => ({
    locale: state.system.locale,
  }),
  null
)(Locales);
